export const FETCH_SELECTED_PROJECT_REQUEST = 'FETCH_SELECTED_PROJECT_REQUEST'
export const FETCH_SELECTED_PROJECT_SUCCESS = 'FETCH_SELECTED_PROJECT_SUCCESS'
export const FETCH_SELECTED_PROJECT_FALUIRE = 'FETCH_SELECTED_PROJECT_FALUIRE'
